<template>
  <component
    :is="image.url ? 'a' : 'div'"
    :href="image.url ? image.url : undefined"
    class="menu-image"
    @click="trackNavigationClick('nav_menu_image_click', $event)"
  >
    <responsive-image
      class="menu-image__image"
      :image="image"
      :sizes="sizes"
      :ratio="ratio"
      :href="image.url"
    />

    <span
      v-if="image.headingText"
      class="menu-image__heading text-body-m-medium"
      v-text="image.headingText"
    />

    <btn
      v-if="image.linkText"
      custom-element="span"
      modifiers="text"
      :label="image.linkText"
    />
  </component>
</template>

<script>
import { trackNavigationClick } from '~/helpers/datalayer-actions';
import Btn from '~global/btn/btn';
import ResponsiveImage from '~global/images/responsive-image';

export default {
  name: 'MenuImage',

  components: {
    ResponsiveImage,
    Btn,
  },

  props: {
    image: {
      type: Object,
      default: () => ({
        alt: '',
        src: '',
        url: '',
        linkText: '',
        headingText: '',
      }),
    },
    ratio: {
      type: String,
      default: '7:6',
    },
    sizes: {
      type: String,
      default: '420px',
    },
  },

  methods: {
    trackNavigationClick,
  },
}
</script>
